import React from 'react';

import Page from 'components/page';
import SolutionTemplate from 'components/solutionTemplate';
import { CTAS } from 'context/solutions/constants';

const sections = [
  {
    title: 'Input Financing Programme',
    image: 'products/input-financing-programme.jpg',
    ctas: [CTAS.READ_MORE, CTAS.START_TRADING],
    description: `
      AFEX's input programme aims to provide access to financing for 
      smallholder farmers to obtain quality inputs while at the same 
      time providing an avenue for people interested in diversifying 
      their investment portfolio to do so. The programme provides a 
      competitive yield over a nine-month investment horizon when 
      compared to other competitive assets classes.`,
  },
  {
    title: 'Financial Inclusion',
    image: 'products/asset-backed-commercial-papers.jpg',
    ctas: [CTAS.READ_MORE, CTAS.VIEW_PROGRESS],
    description: `
      AFEX has a strategic partnership with the Nigeria Inter-bank 
      Settlement System (NIBSS) that allows us to provide a platform 
      for millions of smallholder farmers to be included in the financial 
      sector. With our access to offline BVN devices, we are able to 
      register farmers and profile them.`,
  },
  {
    title: 'Collateral Management',
    image: 'products/collateral-management.jpg',
    ctas: [CTAS.READ_MORE, CTAS.SIGN_UP],
    description: `
      AFEX provides collateral management services for clients, allowing 
      banks and companies to extend credit to the client on the back of 
      electronic warehouse receipts issued by AFEX. The underlying 
      commodities on which the e-Wrs are issued are held in storage in 
      any of AFEX’s storage locations. Warehousing and collateral management 
      services are then provided by AFEX for the period of the engagement 
      and based on the agreed terms.`,
  },
];

const WorkbenchPage = () => {
  return (
    <Page pageName="accessAndRetention">
      <SolutionTemplate sections={sections} />
    </Page>
  );
};

export default WorkbenchPage;
